import React, { useState, useEffect } from "react";
import { Table, Image } from "react-bootstrap";
import BasicPagination from "../../../../../Pagination/Pagination";
import moment from "moment";
import { NOTAVAILABLEIMAGE } from "../../../../../../enums/GlobalEnums";

const RestaurantsFavoritesInsidePage = (props) => {
  //state
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [favourites, setFavourites] = useState(props.data);
  var filteredData = favourites;

  filteredData = filteredData.filter((item) => {
    return (
      item &&
      item.restaurant_id &&
      item.restaurant_id.restaurant_name
        .toLowerCase()
        .includes(props.search.toLowerCase())
    );
  });

  if (props.favouriteFilter.city && props.clickedSearch) {
    filteredData = filteredData.filter((item) => {
      return (
        item &&
        item.restaurant_id &&
        item.restaurant_id.city
          .toLowerCase()
          .includes(props.favouriteFilter.city.toLowerCase())
      );
    });
  }

  if (props.startDate && props.endDate && props.clickedSearch) {
    let ed = new Date(props.endDate).getTime();
    let sd = new Date(props.startDate).getTime();

    filteredData = filteredData.filter((d) => {
      var time = new Date(d.createdAt).getTime();
      return sd < time && time < ed;
    });
  }

  useEffect(() => {
    let sortedDates = [];
    // if (props.data && props.data.favourites && props.data.favourites) {
    //   const items = props.data.favourites;
    //   const reversedItems = items.map((item) => item).reverse();
    //   setFavourites(reversedItems);
    // }
    if (props?.data) {
      if (props.sortByDate === 1) {
        sortedDates = props.data?.sort(function (a, b) {
          return new Date(b.updatedAt) - new Date(a.updatedAt);
        });
      } else if (props.sortByDate === 2) {
        sortedDates = props.data?.sort(function (a, b) {
          return new Date(a.updatedAt) - new Date(b.updatedAt);
        });
      } else {
        sortedDates = props.data?.sort(function (a, b) {
          return new Date(b.updatedAt) - new Date(a.updatedAt);
        });
      }
      setFavourites(sortedDates);
    }
  }, [props.data]);

  useEffect(() => {
    // setSortBy("");
    // setSortName([]);
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [props.search]);
  return (
    <>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
        <Table className="enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <td style={{ width: "25%" }} className="f12-500">
                Restaurant <br />
                Name
              </td>
              <td style={{ width: "25%" }} className="f12-500">
                Location
              </td>
              <td style={{ width: "25%" }} className="f12-500">
                Date/Time
              </td>
              <td style={{ width: "25%" }} className="f12-500">
              Status
              </td>
              {/* <th style={{ width: "25%" }} className="f12-700">
                Status
              </th> */}
            </tr>
          </thead>
          {filteredData.slice(start, end).map((fav, index) => (
            <tbody className="HideShowTable" key={index}>
              <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
                <td style={{ width: "25%" }}>
                  <div className="d-flex flex-column align-items-start">
                    <div className="enImage45 ">
                      <Image
                        //src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                        src={
                          (fav &&
                            fav.restaurant_id &&
                            fav.restaurant_id.logo_url) ||
                          NOTAVAILABLEIMAGE
                        }
                        alt="Restaurant logo"
                        title="Restaurant logo"
                        fluid
                      />
                    </div>
                    <div className="f11-500 text-center mt-1">
                      {fav &&
                        fav.restaurant_id &&
                        fav.restaurant_id.restaurant_name}
                    </div>
                  </div>
                </td>
                <td style={{ width: "25%" }}>
                  <div className="f15-500">
                    {fav && fav.restaurant_id && fav.restaurant_id.city}
                  </div>
                </td>
                <td style={{ width: "25%" }}>
                  <div className="f15-500">
                    {moment(fav.createdAt).format("Do MMM, YYYY")}
                  </div>
                  <div className="f15-500">
                    {moment(fav.createdAt).format("LT")}
                  </div>
                </td>
                <td style={{ width: "25%" }}>
                  <>
                    {fav.message === "Favourite was removed" ? (
                      <div className="f13-400">
                        <span className="enRedDot mr-1"></span>
                        {fav.message}
                      </div>
                    ) : (
                      <div className="f13-400">
                        <span className="enGreenDot mr-1"></span>
                        {fav.message}
                      </div>
                    )}
                  </>
                </td>
                {/* <td style={{ width: "16.66%" }}>
                    <div className="f15-700">Off</div>
                  </td> */}
              </tr>
            </tbody>
          ))}

          {/* <tbody className="HideShowTable">
            <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
              <td style={{ width: "16.66%" }}>
                <div className="d-flex flex-column align-items-start">
                  <div className="enImage45 ">
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </div>
                  <div className="f11-500 text-center mt-1">McDonald</div>
                </div>
              </td>
              <td style={{ width: "16.66%" }}>
                <div className="f15-500">Mumbai</div>
              </td>
              <td style={{ width: "16.66%" }}>
                <div className="f15-500">25th Aug, 2020</div>
                <div className="f15-500">12:15 PM</div>
              </td>
              <td style={{ width: "33.33%" }}>
                <div className="f13-400">
                  <span className="enGreenDot mr-1"></span>Favourite added
                </div>
              </td>
              <td style={{ width: "16.66%" }}>
                <div className="f15-700">On</div>
              </td>
            </tr>
          </tbody> */}
        </Table>
      </div>
      {filteredData.length !== 0 ? (
        <BasicPagination
          totalRecords={filteredData.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <> </>
      )}
    </>
  );
};

export default RestaurantsFavoritesInsidePage;
